import { createSelector } from '@reduxjs/toolkit';
import { userPropertiesForCurrentOrganization } from '../user/userPropertiesForCurrentOrganization';

import type { StaffingCalendarUserDisplaySelection } from '../../../pages/staffing-page/staffing-calendar-user-display-selection';

export const staffingCalendarUserDisplaySelection = createSelector(
  [userPropertiesForCurrentOrganization],
  function (userProperties): StaffingCalendarUserDisplaySelection {
    return (
      userProperties.staffingCalendarUserDisplaySelection || {
        zoom: 'day',
        start: '08',
        end: '16',
      }
    );
  },
);
